import * as React from "react";
import type { SVGProps } from "react";
const SvgBed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#bed_svg__a)">
      <path d="M23 20c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v5c0 .55-.45 1-1 1M1 20c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v14c0 .55-.45 1-1 1" />
      <path d="M23 18H1c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1h20c1.65 0 3 1.35 3 3v4c0 .55-.45 1-1 1M2 16h20v-3c0-.55-.45-1-1-1H2z" />
      <path d="M7 12H3c-1.65 0-3-1.35-3-3s1.35-3 3-3h4c1.65 0 3 1.35 3 3s-1.35 3-3 3M3 8c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1z" />
    </g>
    <defs>
      <clipPath id="bed_svg__a">
        <path fill="#fff" d="M0 4h24v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBed;
